import React from 'react';
import ReactHtmlParser from 'html-react-parser';
import DOMPurify from 'dompurify';

const RHC = ({ surveyJson, pageNo }) => {
    const pages = surveyJson?.pages;

    // Null safety: no pages
    if (!pages || pages.length === 0) return null;

    // Get current page's RHC content (fall back to showing all if pageNo not provided)
    const currentPage = typeof pageNo === 'number' ? pages[pageNo] : null;

    if (currentPage) {
        // Show only current page's RHC
        if (!currentPage.htmlRHC) return null;
        const sanitizedHtml = DOMPurify.sanitize(currentPage.htmlRHC, {
            ALLOWED_ATTR: ['target', 'href', 'class', 'id', 'style'],
        });
        return (
            <div className="container rhc-comp">
                <div className="item-container">
                    <div>
                        {ReactHtmlParser(sanitizedHtml)}
                    </div>
                </div>
            </div>
        );
    }

    // Fallback: show all pages' RHC if pageNo not available
    const hasAnyRhc = pages.some(p => p?.htmlRHC);
    if (!hasAnyRhc) return null;

    return (
        <div className="container rhc-comp">
            <div className="item-container">
                {pages.map((page, index) => {
                    if (!page?.htmlRHC) return null;
                    const sanitizedHtml = DOMPurify.sanitize(page.htmlRHC, {
                        ALLOWED_ATTR: ['target', 'href', 'class', 'id', 'style'],
                    });
                    return (
                        <div key={index}>
                            {ReactHtmlParser(sanitizedHtml)}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RHC;
